import { render, staticRenderFns } from "./WarrantWatch.vue?vue&type=template&id=a9c1a858&scoped=true&"
import script from "./WarrantWatch.js?vue&type=script&lang=js&"
export * from "./WarrantWatch.js?vue&type=script&lang=js&"
import style0 from "./WarrantWatch.vue?vue&type=style&index=0&id=a9c1a858&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c1a858",
  null
  
)

export default component.exports